// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../assets/fonts/Nunito/Nunito.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.Case_360_view {
  font-size: 12px !important;
  font-family: montserrat !important;
}

.labCase_360_view {
  font-family: Nunito, sans-serif !important;
}

.Case_360_view .eventselecttypeControl {
  width: 96%;
  border: none;
  padding-block: 2px;
  height: 28px;
  margin-left: 8px; /* Adjust as needed to provide space between input and buttons */
  padding-right: 23px !important;
}

.Case_360_view .blod_text {
  color: #007887;
}

.Case_360_view .parentsearchdiv {
  background-color: white;
  height: 76px;
  padding-left: 15px;
  padding-right: 15px;
}

.Case_360_view .date_control_style {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  width: 78%;
  float: left;
  min-height: 8vh !important;
  max-height: 8vh !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  background-color: white !important;
  top: 10px;
}

.Case_360_view .case360inputfield {
  position: relative !important;
  bottom: 7px !important;
  padding-top: 5px;
}

.Case_360_view .case360button {
  padding-top: 11px;
}

.Case_360_view .case360userguidance {
  margin-top: 4%;
  margin-left: auto;
  margin-right: auto;
  width: 1359px;
}

.Case_360_view .close_icon {
  position: absolute;
  top: 27%;
  font-size: 16px;
  cursor: pointer;
  color: grey;
  font-weight: 600;
  right: 0;
}

.Case_360_view .help-main-title {
  font-size: 17px;
  text-align: center;
}

.Case_360_view .case_details {
  text-align: center;
  position: relative;
  width: 16%;
  padding-inline: 12px;
  color: #001c3b;
}

.Case_360_view .case_details_title {
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
}

.Case_360_view .caseHeaderBorder {
  height: 14px;
  width: 2px;
  background-color: #17a0b4 !important;
  position: absolute;
  top: 14%;
  right: 0%;
}

.Case_360_view .case_info {
  background: #e2e2e2 0% 0% no-repeat padding-box;
  padding-inline: 8px;
}

::ng-deep.Case_360_view .case_tabs .mat-tab-header {
  height: 33px;
}
::ng-deep.Case_360_view .case_tabs .mat-tab-label {
  height: 31px !important;
  text-transform: uppercase;
}
::ng-deep.Case_360_view .case_tabs .mat-tab-group.mat-primary .mat-ink-bar,
::ng-deep.Case_360_view .case_tabs .mat-tab-nav-bar.mat-primary .mat-ink-bar {
  margin-left: unset !important;
}
::ng-deep.Case_360_view .case_tabs .mat-tab-label-container {
  background-color: transparent;
  border-bottom: 1px solid #17a0b4;
}
::ng-deep.Case_360_view .case_tabs .mat-tab-group.mat-primary .mat-ink-bar {
  background-color: #376b96 !important;
  height: 2px !important;
}
::ng-deep.Case_360_view .case_tabs .mat-tab-label .mat-tab-label-content {
  font-size: 10px !important;
  font-weight: 600 !important;
  font-family: montserrat !important;
}
::ng-deep.Case_360_view .case_tabs .mat-tab-label.mat-ripple.mat-tab-label-active {
  color: #376b96 !important;
  background-color: white !important;
  opacity: unset !important;
}

::ng-deep.Case_360_view .labcase_tabs .mat-tab-header {
  height: 33px;
}
::ng-deep.Case_360_view .labcase_tabs .mat-tab-label {
  height: 31px !important;
  text-transform: uppercase;
}
::ng-deep.Case_360_view .labcase_tabs .mat-tab-group.mat-primary .mat-ink-bar,
::ng-deep.Case_360_view .labcase_tabs .mat-tab-nav-bar.mat-primary .mat-ink-bar {
  margin-left: unset !important;
}
::ng-deep.Case_360_view .labcase_tabs .mat-tab-label-container {
  background-color: transparent;
  border-bottom: 1px solid #17a0b4;
}
::ng-deep.Case_360_view .labcase_tabs .mat-tab-group.mat-primary .mat-ink-bar {
  background-color: #376b96 !important;
  height: 2px !important;
}
::ng-deep.Case_360_view .labcase_tabs .mat-tab-label .mat-tab-label-content {
  font-size: 10px !important;
  font-weight: 600 !important;
  font-family: Nunito, sans-serif !important;
}
::ng-deep.Case_360_view .labcase_tabs .mat-tab-label.mat-ripple.mat-tab-label-active {
  color: #376b96 !important;
  background-color: white !important;
  opacity: unset !important;
}

.Case_360_view .active_img {
  display: none;
}

.Case_360_view .inactive_img {
  display: block;
  margin-right: 9px;
  position: relative;
  top: -2px;
}

.Case_360_view .active_img_inbound {
  display: none;
}

.Case_360_view .inactive_img_inbound {
  display: block;
  margin-right: 11px;
  position: relative;
  top: -2px;
}

::ng-deep.Case_360_view .event_card {
  height: 75vh;
  border-right: 3px solid #007887;
}
::ng-deep.Case_360_view .event_card .header {
  height: 50px;
  background: #f2f2f2 0% 0% no-repeat padding-box;
}
::ng-deep.Case_360_view .event_card .header .search_control {
  width: 90%;
  height: 28px;
  margin: auto;
  border-radius: 5px;
  border: 1px solid #001c3b;
  background-color: white;
}
::ng-deep.Case_360_view .event_card .header .search_control .search_icon {
  position: relative;
  left: 2%;
  top: 10%;
}
::ng-deep.Case_360_view .event_card .header .search_control .input_control {
  width: 93%;
  border: none;
  background-color: transparent;
  position: relative;
  left: 3%;
  top: 13%;
}
::ng-deep.Case_360_view .event_card .Case_360_view .mat-tab-label {
  height: 37px !important;
  flex: 1 !important;
  text-transform: uppercase;
}
::ng-deep.Case_360_view .event_card .Case_360_view .mat-tab-group.mat-primary .mat-ink-bar,
::ng-deep.Case_360_view .event_card .mat-tab-nav-bar.mat-primary .mat-ink-bar {
  margin-left: unset !important;
}
::ng-deep.Case_360_view .event_card .Case_360_view .mat-tab-label-container {
  background-color: #f3f3f3 !important;
}
::ng-deep.Case_360_view .event_card .Case_360_view .mat-tab-group.mat-primary .mat-ink-bar {
  background-color: #17a0b4 !important;
  height: 3px !important;
}
::ng-deep.Case_360_view .event_card .Case_360_view .mat-tab-label .mat-tab-label-content {
  font-size: 12px !important;
  font-weight: 600 !important;
}
::ng-deep.Case_360_view .event_card .Case_360_view .mat-tab-label.mat-ripple.mat-tab-label-active {
  color: #17a0b4 !important;
  background-color: white !important;
  opacity: unset !important;
}
::ng-deep.Case_360_view .event_card .Case_360_view .mat-tab-label.mat-ripple.mat-tab-label-active .outbound_style .active_img {
  display: block !important;
  margin-right: 9px;
  position: relative;
  top: -2px;
}
::ng-deep.Case_360_view .event_card .Case_360_view .mat-tab-label.mat-ripple.mat-tab-label-active .outbound_style .inactive_img {
  display: none !important;
}
::ng-deep.Case_360_view .event_card .Case_360_view .mat-tab-label.mat-ripple.mat-tab-label-active .inbound_style .active_img_inbound {
  display: block !important;
  margin-right: 11px;
  position: relative;
  top: -2px;
}
::ng-deep.Case_360_view .event_card .Case_360_view .mat-tab-label.mat-ripple.mat-tab-label-active .inbound_style .inactive_img_inbound {
  display: none !important;
}

.Case_360_view .event_card_info {
  height: 75vh;
  border-left: 3px solid #007887;
  margin-left: 2px;
}
.Case_360_view .event_card_info .header {
  height: 50px;
  background: #f2f2f2 0% 0% no-repeat padding-box;
}

.Case_360_view .Event_lables {
  height: 60px;
  background: #e5f1f3;
  padding-inline: 13px;
}

.Case_360_view .eventtype_lables {
  background-color: white;
  padding-inline: 4%;
  padding-block: 0px;
  margin: 8px;
  display: inline-block;
  border-radius: 50pc;
  cursor: pointer;
  box-shadow: 1px 1px 4px 0px grey;
}

.Case_360_view .eventtype_lables_active {
  background-color: #007887;
  padding-inline: 4%;
  padding-block: 0px;
  margin: 8px;
  display: inline-block;
  border-radius: 50pc;
  cursor: pointer;
  color: white;
  box-shadow: 1px 1px 4px 0px grey;
}

.Case_360_view .messageInfo {
  border-left: 4px solid green;
  box-shadow: 1px 1px 6px 0px grey;
  border-radius: 5px;
  padding-inline: 6px;
  padding-block: 3px;
}

.Case_360_view .cardActive {
  background-color: #cce4e7;
}

.Case_360_view .listview {
  padding-inline: 19px;
  max-height: 53vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.Case_360_view .view_file_icon {
  width: 19px !important;
  float: left;
  position: relative;
  top: -3px;
  left: 6px;
}

.Case_360_view .barline {
  height: 1px;
  background-color: black;
  margin-inline: 13px;
}

::ng-deep.Case_360_view.message_menu.mat-menu-panel button.mat-menu-item {
  height: 26px !important;
  line-height: 26px !important;
  text-align: center !important;
  color: #179fb3 !important;
  font-size: 13px !important;
}

.Case_360_view .lables_status {
  border-radius: 4px;
  padding-block: 3px;
  font-size: 10px;
  font-weight: 600;
}

::ng-deep.Case_360_view .viewstages .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.Case_360_view .viewstages {
  top: 4% !important;
}

.Case_360_view .inputContainer {
  height: 81vh;
  background-color: #f3f3f3;
  border: 1px solid #707070;
}
.Case_360_view .inputContainer .header {
  background-color: #d1d1d1;
  font-size: 12px;
  font-weight: 500;
  border-bottom: 1px solid #707070;
}

.Case_360_view .outputContainer {
  height: 81vh;
  background-color: #f3f3f3;
  border: 1px solid #707070;
}
.Case_360_view .outputContainer .header {
  background-color: #d1d1d1;
  font-size: 12px;
  font-weight: 500;
  border-bottom: 1px solid #707070;
}

.Case_360_view .icons_list_style {
  width: 5%;
  padding-bottom: 8px;
  text-align: center;
  margin-inline: 3px;
}

.Case_360_view .icons_list_style_active {
  border-bottom: 3px solid #00bcd4;
  width: 5%;
  padding-bottom: 8px;
  text-align: center;
  margin-inline: 3px;
}

.Case_360_view .case_info_container {
  border: 1.5px solid #17a0b4;
  padding: 5px;
  position: relative;
  margin-block: 16px;
}

.Case_360_view .card_label_title {
  background-color: #fbfbfb;
  position: absolute;
  padding-inline: 5px;
  font-size: 10px;
  top: -9px;
  color: #001c3b;
  font-weight: 600;
}

.Case_360_view .lables_style {
  font-size: 10px;
  color: black;
}

.Case_360_view .value_style {
  font-weight: 600;
  font-size: 10px;
  color: #17a0b4 !important;
}

.Case_360_view .case_details_info {
  height: 17.5vh;
}

.Case_360_view .dates_info {
  height: 24vh;
}

.Case_360_view .case_info_data {
  height: 26vh;
}

.Case_360_view .case_patient_info {
  height: 37vh;
}

.Case_360_view .case_Information_info {
  height: 30vh;
}

.Case_360_view .case_Contact_info {
  height: 29vh;
}

.Case_360_view .case_Insurance_info {
  height: 16vh;
}

.Case_360_view .case_DX_reports {
  height: 11vh;
}

.Case_360_view .case_send_in_details {
  height: 11vh;
}

.Case_360_view .case_referring_details {
  height: 14vh;
}

.Case_360_view .case_laboratory_details {
  height: 17vh;
}

.Case_360_view .case_orderingfacility_details {
  height: 17vh;
}

.Case_360_view .case_send_out_details {
  height: 11vh;
}

.Case_360_view .sec_date {
  font-size: 10px;
}

.Case_360_view .pt_date {
  font-size: 9px;
  margin-left: 3px;
}

.Case_360_view .more_info {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.Case_360_view .orderedDate {
  color: #827ec4 !important;
}

.Case_360_view .collectionDate {
  color: #80a8d0 !important;
}

.receivedDate {
  color: #278c7d !important;
}

.signedoutDate {
  color: #d17800 !important;
}

.reportDate {
  color: #c02755 !important;
}

.sendinDate {
  color: #443ea7 !important;
}

.sendoutDate {
  color: #3575b5 !important;
}

.insurance_more_info {
  height: 62.5vh;
}

.text_elip {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
}

.flag_class {
  background-color: #e8e8e5;
  min-width: auto;
  border-radius: 3px;
  color: #001c3b;
  font-size: 11px;
  min-width: 164px !important;
  padding-inline: 6px;
  padding-block: 2px;
  margin: 3px;
  max-width: 320px;
}

.no_data {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #001C3B;
}

.search_control {
  width: 61% !important;
}

.demo_text {
  font-size: 15px;
}

.box_sizing_search {
  box-sizing: content-box;
  width: 98%;
}

.casecard {
  background-color: white;
  box-shadow: 1px 1px 4px 0px rgba(52, 46, 46, 0.6588235294);
  padding-inline: 5px;
  justify-content: space-around;
  margin-block: 6px;
  border-radius: 2px;
  margin-inline: 10px;
  padding-block: 7px;
  cursor: pointer;
}

.chevronleftbtnact {
  background-color: green;
  color: white;
  cursor: pointer;
}

.chevronleftbtninact {
  background-color: red;
  color: white;
  margin-left: 1%;
}

.chevronleft {
  margin: auto;
  justify-content: center;
  display: flex;
}

.pointer {
  cursor: pointer;
}

.time-ago {
  font-size: 0.7rem;
  text-align: right;
  top: -2px;
  right: 45px;
}

.advance-search {
  margin-top: 20px;
  padding-left: 0px;
}

.button-go {
  display: block !important;
  margin-top: 11px !important;
}

.spinner-border {
  display: inline-block;
  padding-left: 600px;
  margin-top: 200px;
  border-left-width: 100px;
  margin-left: 100px;
  margin-right: 100px;
  margin-bottom: 200px;
  padding-right: 500px;
}

.mat-tab-group.mat-primary .mat-ink-bar,
.mat-tab-nav-bar.mat-primary .mat-ink-bar {
  background-color: #00bcd4 !important;
}

.card-headers {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 99%;
  height: 25px;
  display: flex;
}

.modal-popup-displaytext {
  padding-left: 12px;
}

.modal-popup-header {
  font-size: 13px;
  font-weight: 500;
  padding-left: 25px;
}

.modal-popup-content {
  font-size: 12px;
  font-weight: 400;
}

.card-header-text {
  font-size: 13px;
  color: slateblue;
}

.other-info {
  height: 238px !important;
}

.close-button-icon {
  padding-right: 10px;
  padding-top: 10px;
}

.filter-key {
  padding-bottom: 0.5rem;
}

.filter-values {
  margin-bottom: 0px;
}

.filter-box {
  box-shadow: 0 0 0px rgba(0, 0, 0, 0);
  height: calc(100vh - 225px);
  overflow-x: hidden;
  overflow-y: auto;
}

.filter-parent-height {
  background: #ffffff;
  padding: 0;
}

.box-body {
  padding: 0.5rem !important;
}

.scroll-height {
  overflow: auto;
  padding-right: 15px;
}

.box-header {
  padding-bottom: 0 !important;
}

.show {
  display: block;
}

.hidden {
  display: none;
}

.Case_360_view .dropdown-menu a:hover {
  font-size: 12px;
  font-weight: 600;
}

.Case_360_view .dropdown-menu a {
  padding: 0;
  color: black;
}

.noDataFound .col-4 {
  height: 25px;
}
.noDataFound .col-8 {
  height: 0;
}
.noDataFound .message {
  display: flex;
}
.noDataFound .onload-t {
  color: rgba(0, 0, 0, 0.8784313725);
}
.noDataFound .onload-b {
  margin-top: 15px;
  color: #756d6d;
}

.advresultmsg {
  margin-bottom: 0px;
}

.panel-right-filter {
  position: inherit;
  right: 0px;
  z-index: 100;
  height: auto;
}

.a-s-f {
  display: flex;
  padding-left: 0.7rem;
}

.chip-list {
  padding: 0.2rem 0.2rem 0 0.5rem;
}

.Case_360_view .chip {
  border: 1px solid #0079b8;
  background-color: #ffffff;
  font-size: 0.7rem;
  font-weight: 400;
  line-height: 0.458333rem;
  align-items: center;
  min-height: 1.25rem;
  margin: 0 0.25rem 0 0 !important;
  white-space: nowrap;
}
.Case_360_view .chip .chip-icon {
  color: rgb(13, 135, 225) !important;
  opacity: 1.4 !important;
  margin: 0 -0.375rem 0 0.25rem !important;
}

.mat-chip.mat-standard-chip::after {
  background: #0d87e1;
}

.drop-down-caret::before {
  content: "\\f0d7";
}

.drop-down-caret.collapsed::before {
  content: "\\f0da";
}

.help_label {
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.help-inline-wrap {
  padding: 0px 40px 0px 40px !important;
}

.help-headline {
  text-align: center;
  line-height: 1.2;
  margin-bottom: 20px;
}

.help-main-title {
  font-size: 24px;
}

.help-sub-title {
  font-size: 18px;
}

.deployment-title {
  font-size: 18px;
}

.pdf-align {
  color: #00bcd4;
  font-size: 22px;
}

.logo-align {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.icon-size {
  width: 25px;
  height: auto;
  opacity: 0.5;
  cursor: pointer;
}

.list-icon-remove {
  list-style-type: none;
}

.border-bottom {
  border-bottom: 1px solid #e5e1e1;
}

.icon-size:hover {
  font-weight: 600;
}

.dropdown-menu {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  font-size: 12px;
}

.dropdown-content:after {
  content: "";
  /* Required to display content */
  position: absolute;
  /* Sets the position absolute to the top div */
  top: 0;
  left: 5%;
  margin-top: -10px;
  width: 0;
  z-index: 1;
  height: 0;
  border-bottom: solid 10px #fff;
  /* Creates the arrow pointing up, to change to a notch instead user border-top */
  border-left: solid 10px transparent;
  /* Creates triangle effect */
  border-right: solid 10px transparent;
  /* Creates triangle effect */
}

/* Style the links inside the dropdown */
.dropdown-content a {
  float: none;
  color: #333;
  text-decoration: none;
  display: block;
  text-align: left;
}

#caseAssign .modal-footer {
  justify-content: center !important;
}

::ng-deep .popup-dropdown .mat-form-field-infix {
  width: 415px !important;
  height: 45px !important;
}

.dropdown-item:hover {
  font-weight: 600 !important;
}

img.dropdown-item:hover {
  opacity: 0.9;
}

::ng-deep .assign-wrap .mat-form-field-appearance-outline .mat-form-field-infix {
  padding: 0.2em 0 0.6em 0 !important;
}

#caseAssign .modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px !important;
  border-bottom: 1px solid #eceeef;
  background: #00bcd4 !important;
  color: #fff !important;
  border-radius: 10px 10px 0px 0px !important;
}

#caseAssign .modal-content {
  border-radius: 10px !important;
}

#caseAssign .modal-title {
  font-size: 20px !important;
  font-weight: normal !important;
}

#caseAssign button.close {
  color: #fff !important;
  font-weight: normal !important;
}

.Case_360_view .display-text {
  height: 20px;
}

.Case_360_view .date-align {
  height: auto;
}

.Case_360_view .search-align {
  float: left;
  padding-left: 10px !important;
}

.Case_360_view .icon-wrap {
  margin-top: 6px;
}

.Case_360_view .icon-color {
  color: grey;
}

.Case_360_view .icon-handler {
  margin-left: 15px;
}

.Case_360_view .drop-down-wrap {
  margin-bottom: 5px;
}

.Case_360_view .label-wrap {
  margin-bottom: 5px;
}

.Case_360_view .input-wrap {
  width: 90%;
  margin-bottom: 5px;
}

.Case_360_view .assign-icon {
  opacity: 0.6 !important;
}

::ng-deep.Case_360_view .drop-down-wrap .mat-form-field-appearance-outline .mat-select-arrow-wrapper {
  display: none !important;
}

::ng-deep.Case_360_view .case-assign-action .modal-content {
  margin: 140px auto !important;
}

.Case_360_view .drop-down-wrap input.input-width {
  width: 90% !important;
}

.Case_360_view .modal-height {
  margin: 0px !important;
}

.Case_360_view .desc-font {
  font-size: 10px;
}

.Case_360_view .dropdown-border .form-control {
  border-radius: 5px !important;
}

.Case_360_view .entitycard-wrap {
  color: #000 !important;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  font-size: 12px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.Case_360_view .border-help {
  border-bottom: 1px solid #bebdbd;
}

.Case_360_view .deployment-align {
  border-right: 1px solid #bebdbd;
  display: flex;
  align-items: center;
  justify-content: left;
}

::ng-deep.Case_360_view .wj-cell.wj-align-right:nth-child(5) {
  text-align: left !important;
}

.Case_360_view .deploy-table {
  font-size: 12px !important;
  border: 1px solid rgba(112, 112, 112, 0.5019607843);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  height: auto;
  overflow-y: scroll;
}

.Case_360_view .header-border {
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}

.Case_360_view .font-bold {
  font-weight: 600;
}

.Case_360_view .sub-search {
  display: flex;
  justify-content: flex-end;
}

.Case_360_view .word-break {
  word-break: break-all;
}

.Case_360_view .title-wraps {
  display: table;
  border: 1px solid rgba(112, 112, 112, 0.5019607843);
  color: #fff;
  background: #00bbd3;
}

::ng-deep.Case_360_view .mat-menu-panel {
  max-width: 450px !important;
  min-width: 400px !important;
  overflow: hidden !important;
}

::ng-deep.Case_360_view .mat-menu-content:not(:empty) {
  padding-top: 0% !important;
  padding-bottom: 0% !important;
}

label {
  width: 112px; /* Set a fixed width for the labels */
  margin-right: 5px;
  height: 20px;
}

/* Optional: Adjust the appearance of the autocomplete dropdown */
::ng-deep.Case_360_view .mat-autocomplete-panel {
  border: 1px solid #ccc; /* Dropdown border color */
  background-color: #fff; /* Dropdown background color */
  top: 100% !important;
}

::ng-deep.Case_360_view .form-style {
  overflow: hidden;
  font-size: 11px;
}

::ng-deep.Case_360_view .mat-chip.mat-standard-chip {
  height: 1px;
  min-height: 20px;
}

::ng-deep.Case_360_view .autocomplete-container .input-container input {
  padding-right: 5% !important;
  font-size: 11px !important;
  height: 33px !important;
}

::ng-deep.Case_360_view .form-control {
  padding: 4px;
}

::ng-deep.Case_360_view .mat-form-field-infix {
  display: contents !important;
}

.Case_360_view .customchip {
  font-size: 12px;
  min-height: 21px !important;
  padding-inline: 8px !important;
  float: left !important;
  margin-inline-start: 12px;
  font-size: 12px;
  padding: 2px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-left: 2px;
  margin-top: 7px;
}

::ng-deep.Case_360_view .mat-button, .mat-flat-button, .mat-icon-button, .mat-stroked-button {
  min-width: 25px !important;
  padding: 1px !important;
}

.Case_360_view .case360asterisk {
  font-size: 6px;
  position: absolute;
}

.Case_360_view .filterbtn {
  line-height: 20px;
  font-size: 16px !important;
  top: 0px;
  min-width: 25px !important;
}

.Case_360_view .userguidancemaindiv {
  height: 69vh;
}

.Case_360_view .searchformbtns {
  padding-left: 18px;
}

::ng-deep.mat_tab_styles_case360 .mat-mdc-tab-label-container {
  background-color: white !important;
}
::ng-deep.mat_tab_styles_case360 .mat-mdc-tab-label-container .mat-mdc-tab-labels {
  height: 37px !important;
}
::ng-deep.mat_tab_styles_case360 .mat-mdc-tab-label-container .mat-mdc-tab {
  font-weight: 600;
  font-size: 12px !important;
  padding-bottom: 8px;
  letter-spacing: normal;
  font-family: montserrat !important;
}
::ng-deep.mat_tab_styles_case360 .mat-mdc-tab-label-container .mat-mdc-tab .mdc-tab__text-label {
  position: relative;
  bottom: 7%;
  color: black;
}
::ng-deep.mat_tab_styles_case360 .mat-mdc-tab-label-container .mat-mdc-tab.mdc-tab--active {
  background-color: white !important;
  opacity: unset !important;
}
::ng-deep.mat_tab_styles_case360 .mat-mdc-tab-label-container .mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #17a0b4 !important;
}
::ng-deep.mat_tab_styles_case360 .mat-mdc-tab-label-container .mat-mdc-tab.mdc-tab--active .mdc-tab-indicator .mdc-tab-indicator__content {
  background-color: #17a0b4 !important;
  height: 7px;
  border-color: transparent;
}
::ng-deep.mat_tab_styles_case360 .mat-mdc-tab-body-wrapper {
  height: 70vh !important;
}
::ng-deep.mat_tab_styles_case360 .mat-mdc-tab-body-wrapper .mat-mdc-tab-body-content {
  overflow-y: auto;
  overflow-x: hidden;
}

::ng-deep.mat_tab_styles_labcase360 .mat-mdc-tab-label-container {
  background-color: white !important;
}
::ng-deep.mat_tab_styles_labcase360 .mat-mdc-tab-label-container .mat-mdc-tab-labels {
  height: 37px !important;
  background-color: #d2d2d2 !important;
}
::ng-deep.mat_tab_styles_labcase360 .mat-mdc-tab-label-container .mat-mdc-tab {
  font-weight: 600;
  font-size: 12px !important;
  padding-bottom: 8px;
  letter-spacing: normal;
  font-family: Nunito, sans-serif !important;
  border-right: 1px solid #ababab;
}
::ng-deep.mat_tab_styles_labcase360 .mat-mdc-tab-label-container .mat-mdc-tab .mdc-tab__text-label {
  position: relative;
  bottom: 7%;
  color: black;
}
::ng-deep.mat_tab_styles_labcase360 .mat-mdc-tab-label-container .mat-mdc-tab.mdc-tab--active {
  background-color: white !important;
  opacity: unset !important;
}
::ng-deep.mat_tab_styles_labcase360 .mat-mdc-tab-label-container .mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #17a0b4 !important;
}
::ng-deep.mat_tab_styles_labcase360 .mat-mdc-tab-label-container .mat-mdc-tab.mdc-tab--active .mdc-tab-indicator .mdc-tab-indicator__content {
  background-color: #17a0b4 !important;
  height: 7px;
  border-color: transparent;
}
::ng-deep.mat_tab_styles_labcase360 .mat-mdc-tab-body-wrapper {
  height: 83vh !important;
}
::ng-deep.mat_tab_styles_labcase360 .mat-mdc-tab-body-wrapper .mat-mdc-tab-body-content {
  overflow-y: auto;
  overflow-x: hidden;
}

::ng-deep.mat_tab_styles_jupcase360 .mat-mdc-tab-label-container {
  background-color: white !important;
}
::ng-deep.mat_tab_styles_jupcase360 .mat-mdc-tab-label-container .mat-mdc-tab-labels {
  height: 37px !important;
  background-color: #d2d2d2 !important;
}
::ng-deep.mat_tab_styles_jupcase360 .mat-mdc-tab-label-container .mat-mdc-tab {
  font-weight: 600;
  font-size: 12px !important;
  padding-bottom: 8px;
  letter-spacing: normal;
  font-family: Nunito, sans-serif !important;
  border-right: 1px solid #ababab;
}
::ng-deep.mat_tab_styles_jupcase360 .mat-mdc-tab-label-container .mat-mdc-tab .mdc-tab__text-label {
  position: relative;
  bottom: 7%;
  color: black;
}
::ng-deep.mat_tab_styles_jupcase360 .mat-mdc-tab-label-container .mat-mdc-tab.mdc-tab--active {
  background-color: white !important;
  opacity: unset !important;
}
::ng-deep.mat_tab_styles_jupcase360 .mat-mdc-tab-label-container .mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #17a0b4 !important;
}
::ng-deep.mat_tab_styles_jupcase360 .mat-mdc-tab-label-container .mat-mdc-tab.mdc-tab--active .mdc-tab-indicator .mdc-tab-indicator__content {
  background-color: #17a0b4 !important;
  height: 7px;
  border-color: transparent;
}
::ng-deep.mat_tab_styles_jupcase360 .mat-mdc-tab-body-wrapper {
  height: 78vh !important;
}
::ng-deep.mat_tab_styles_jupcase360 .mat-mdc-tab-body-wrapper .mat-mdc-tab-body-content {
  overflow-y: auto;
  overflow-x: hidden;
}

::ng-deep.customautocomplete.mat-mdc-autocomplete-panel {
  position: fixed !important;
  top: 27% !important;
  width: inherit !important;
}

::ng-deep.customautocompletedx.mat-mdc-autocomplete-panel {
  position: fixed !important;
  top: 19% !important;
  width: inherit !important;
}

::ng-deep.custommatmenu.mat-mdc-menu-panel {
  max-width: 450px !important;
  min-width: 400px !important;
}
::ng-deep.custommatmenu.mat-mdc-menu-panel .mat-mdc-menu-content {
  padding-block: 0 !important;
}

/* Case 360 Advance filter menu (Accession #, etc.) — override global flex-start on menu overlays */
::ng-deep .cdk-overlay-pane:has(.custommatmenu.mat-mdc-menu-panel) {
  align-self: auto !important;
}

::ng-deep.customstyle .mat-mdc-form-field {
  width: 100% !important;
  position: relative !important;
  bottom: 8px !important;
}
::ng-deep.customstyle .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  background-color: white !important;
}
::ng-deep.customstyle .mat-mdc-form-field .mat-mdc-text-field-wrapper .mdc-line-ripple {
  display: none !important;
}
::ng-deep.customstyle .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-focus-overlay {
  background-color: white !important;
}
::ng-deep.customstyle .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex {
  min-height: 38px !important;
}
::ng-deep.customstyle .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  max-height: 250px !important;
  padding-bottom: 0px !important;
  min-height: 42px !important;
}
::ng-deep.customstyle .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-input-element {
  font-size: 12px !important;
  width: 150px;
  flex: 1 0 150px !important;
  margin-left: 4px;
}
::ng-deep.customstyle .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip {
  height: 24px !important;
  float: left !important;
  margin-inline: 1px !important;
}
::ng-deep.customstyle .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip .mdc-evolution-chip__text-label {
  font-size: 12px !important;
}
::ng-deep.customstyle .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper {
  background-color: white !important;
}
::ng-deep.customstyle .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mdc-line-ripple {
  display: none !important;
}
::ng-deep.customstyle .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-focus-overlay {
  background-color: white !important;
}
::ng-deep.customstyle .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  display: flex !important;
  padding-top: 5px !important;
}
::ng-deep.customstyle .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-input-element {
  font-size: 12px !important;
  width: 150px !important;
  flex: 1 0 150px !important;
  margin-left: 4px;
}
::ng-deep.customstyle .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip {
  height: 24px !important;
  float: left !important;
  margin-inline: 1px !important;
}
::ng-deep.customstyle .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip .mdc-evolution-chip__text-label {
  font-size: 12px !important;
}
::ng-deep.customstyle .mat-mdc-form-field .mat-focused .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
::ng-deep.customstyle .mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}

::ng-deep.myCustomModalViewfilecase360 .modal-dialog {
  margin: 0;
}
::ng-deep.myCustomModalViewfilecase360 .modal-dialog .modal-content {
  width: 60vw;
}

::ng-deep.myCustomModalClasscase360audit .modal-dialog {
  max-width: 97%;
  max-height: 60%;
  height: 60%;
  margin-block: 0px !important;
  margin: auto;
  padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/case360/case360.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB;EACE,0BAAA;EACA,kCAAA;AAAF;;AAEA;EACE,0CAAA;AACF;;AAEA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA,EAAA,gEAAA;EACA,8BAAA;AACF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAEF;;AACA;EACE,+GAAA;EAEA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,0BAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,kCAAA;EACA,SAAA;AACF;;AAEA;EACC,6BAAA;EACA,sBAAA;EACA,gBAAA;AACD;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,QAAA;AACF;;AACA;EACE,eAAA;EACA,kBAAA;AAEF;;AAAA;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;AAGF;;AADA;EACE,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAIF;;AAFA;EACE,YAAA;EACA,UAAA;EACA,oCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAKF;;AAHA;EACE,+CAAA;EACA,mBAAA;AAMF;;AAHE;EACE,YAAA;AAMJ;AAJE;EACE,uBAAA;EACA,yBAAA;AAMJ;AAJE;;EAEE,6BAAA;AAMJ;AAHE;EACE,6BAAA;EACA,gCAAA;AAKJ;AAHE;EACE,oCAAA;EACA,sBAAA;AAKJ;AAHE;EACE,0BAAA;EACA,2BAAA;EACA,kCAAA;AAKJ;AAFE;EACE,yBAAA;EACA,kCAAA;EACA,yBAAA;AAIJ;;AAAE;EACE,YAAA;AAGJ;AADE;EACE,uBAAA;EACA,yBAAA;AAGJ;AADE;;EAEE,6BAAA;AAGJ;AAAE;EACE,6BAAA;EACA,gCAAA;AAEJ;AAAE;EACE,oCAAA;EACA,sBAAA;AAEJ;AAAE;EACE,0BAAA;EACA,2BAAA;EACA,0CAAA;AAEJ;AACE;EACE,yBAAA;EACA,kCAAA;EACA,yBAAA;AACJ;;AAGA;EACE,aAAA;AAAF;;AAEA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AACF;;AACA;EACE,aAAA;AAEF;;AAAA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAGF;;AADA;EACE,YAAA;EACA,+BAAA;AAIF;AAHE;EACE,YAAA;EACA,+CAAA;AAKJ;AAJI;EACE,UAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;AAMN;AALM;EACE,kBAAA;EACA,QAAA;EACA,QAAA;AAOR;AALM;EACE,UAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;AAOR;AAFE;EACE,uBAAA;EACA,kBAAA;EACA,yBAAA;AAIJ;AAFE;;EAEE,6BAAA;AAIJ;AADE;EACE,oCAAA;AAGJ;AADE;EACE,oCAAA;EACA,sBAAA;AAGJ;AADE;EACE,0BAAA;EACA,2BAAA;AAGJ;AAAE;EACE,yBAAA;EACA,kCAAA;EACA,yBAAA;AAEJ;AAAM;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AAER;AAAM;EACE,wBAAA;AAER;AAEM;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAAR;AAEM;EACE,wBAAA;AAAR;;AAKA;EACE,YAAA;EACA,8BAAA;EACA,gBAAA;AAFF;AAGE;EACE,YAAA;EACA,+CAAA;AADJ;;AAIA;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AADF;;AAGA;EACE,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;AAAF;;AAGA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,gCAAA;AAAF;;AAIA;EACE,4BAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AADF;;AAIA;EACE,WAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAKE;EACE,uBAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;EACA,0BAAA;AAFJ;;AAMA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAHF;;AAMA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAHF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,YAAA;EACA,yBAAA;EACA,yBAAA;AAFF;AAGE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AADJ;;AAIA;EACE,YAAA;EACA,yBAAA;EACA,yBAAA;AADF;AAEE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAAJ;;AAIA;EACE,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AADF;;AAGA;EACE,gCAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,2BAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,eAAA;EACA,YAAA;AAAF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AACA;EACE,YAAA;AAEF;;AAAA;EACE,YAAA;AAGF;;AAAA;EACE,YAAA;AAGF;;AADA;EACE,YAAA;AAIF;;AAFA;EACE,YAAA;AAKF;;AAHA;EACE,YAAA;AAMF;;AAJA;EACE,YAAA;AAOF;;AALA;EACE,YAAA;AAQF;;AANA;EACE,YAAA;AASF;;AAPA;EACE,YAAA;AAUF;;AARA;EACE,YAAA;AAWF;;AATA;EACE,YAAA;AAYF;;AAVA;EACE,eAAA;AAaF;;AAXA;EACE,cAAA;EACA,gBAAA;AAcF;;AAXA;EACE,WAAA;EACA,0BAAA;EACA,eAAA;AAcF;;AAXA;EACE,yBAAA;AAcF;;AAZA;EACE,yBAAA;AAeF;;AAbA;EACE,yBAAA;AAgBF;;AAdA;EACE,yBAAA;AAiBF;;AAfA;EACE,yBAAA;AAkBF;;AAhBA;EACE,yBAAA;AAmBF;;AAjBA;EACE,yBAAA;AAoBF;;AAjBA;EACE,cAAA;AAoBF;;AAjBA;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;AAoBF;;AAjBA;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAoBF;;AAjBA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;AAoBF;;AAjBA;EACE,qBAAA;AAoBF;;AAlBA;EACE,eAAA;AAqBF;;AAlBA;EACE,uBAAA;EACA,UAAA;AAqBF;;AAlBA;EACE,uBAAA;EACA,0DAAA;EACA,mBAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAqBF;;AAlBA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;AAqBF;;AAnBA;EACE,qBAAA;EACA,YAAA;EACA,eAAA;AAsBF;;AAnBA;EACE,YAAA;EACA,uBAAA;EACA,aAAA;AAsBF;;AAjBA;EACE,eAAA;AAoBF;;AAjBA;EACE,iBAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;AAoBF;;AAjBA;EACE,gBAAA;EACA,iBAAA;AAoBF;;AAjBA;EACE,yBAAA;EACA,2BAAA;AAoBF;;AAjBA;EACE,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;AAoBF;;AAjBA;;EAEE,oCAAA;AAoBF;;AAjBA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;AAoBF;;AAjBA;EACE,kBAAA;AAoBF;;AAjBA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAoBF;;AAjBA;EACE,eAAA;EACA,gBAAA;AAoBF;;AAjBA;EACE,eAAA;EACA,gBAAA;AAoBF;;AAjBA;EACE,wBAAA;AAoBF;;AAjBA;EACE,mBAAA;EACA,iBAAA;AAoBF;;AAjBA;EACE,sBAAA;AAoBF;;AAjBA;EACE,kBAAA;AAoBF;;AAjBA;EACE,oCAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;AAoBF;;AAjBA;EACE,mBAAA;EACA,UAAA;AAoBF;;AAjBA;EACE,0BAAA;AAoBF;;AAjBA;EACE,cAAA;EACA,mBAAA;AAoBF;;AAjBA;EACE,4BAAA;AAoBF;;AAjBA;EACE,cAAA;AAoBF;;AAjBA;EACE,aAAA;AAoBF;;AAjBA;EACE,eAAA;EACA,gBAAA;AAoBF;;AAjBA;EACE,UAAA;EACA,YAAA;AAoBF;;AAhBE;EACE,YAAA;AAmBJ;AAhBE;EACE,SAAA;AAkBJ;AAfE;EACE,aAAA;AAiBJ;AAdE;EACE,kCAAA;AAgBJ;AAbE;EACE,gBAAA;EACA,cAAA;AAeJ;;AAXA;EACE,kBAAA;AAcF;;AAXA;EACE,iBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;AAcF;;AAXA;EACE,aAAA;EACA,oBAAA;AAcF;;AAXA;EACE,+BAAA;AAcF;;AAXA;EACE,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;EACA,mBAAA;AAcF;AAZE;EACE,mCAAA;EACA,uBAAA;EACA,wCAAA;AAcJ;;AAVA;EACE,mBAAA;AAaF;;AAVA;EACE,gBAAA;AAaF;;AAVA;EACE,gBAAA;AAaF;;AAVA;EACE,cAAA;EACA,uBAAA;EACA,mBAAA;AAaF;;AAVA;EACE,qCAAA;AAaF;;AAVA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AAaF;;AAVA;EACE,eAAA;AAaF;;AAVA;EACE,eAAA;AAaF;;AAVA;EACE,eAAA;AAaF;;AAVA;EACE,cAAA;EACA,eAAA;AAaF;;AAVA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AAaF;;AAVA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAaF;;AAVA;EACE,qBAAA;AAaF;;AAVA;EACE,gCAAA;AAaF;;AAVA;EACE,gBAAA;AAaF;;AAVA;EACE,6CAAA;EACA,eAAA;AAaF;;AAVA;EACE,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,8CAAA;EACA,MAAA;EACA,QAAA;EACA,iBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,8BAAA;EACA,gFAAA;EACA,mCAAA;EACA,4BAAA;EACA,oCAAA;EACA,4BAAA;AAaF;;AAVA,wCAAA;AACA;EACE,WAAA;EACA,WAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAaF;;AAVA;EACE,kCAAA;AAaF;;AAVA;EACE,uBAAA;EACA,uBAAA;AAaF;;AAVA;EACE,2BAAA;AAaF;;AAVA;EACE,YAAA;AAaF;;AAVA;EAIE,mCAAA;AAUF;;AAPA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,gCAAA;EACA,8BAAA;EACA,sBAAA;EACA,2CAAA;AAUF;;AAPA;EACE,8BAAA;AAUF;;AAPA;EACE,0BAAA;EACA,8BAAA;AAUF;;AAPA;EACE,sBAAA;EACA,8BAAA;AAUF;;AAPA;EACE,YAAA;AAUF;;AAPA;EACE,YAAA;AAUF;;AAPA;EACE,WAAA;EACA,6BAAA;AAUF;;AAPA;EACE,eAAA;AAUF;;AAPA;EACE,WAAA;AAUF;;AAPA;EACE,iBAAA;AAUF;;AAPA;EACE,kBAAA;AAUF;;AAPA;EACE,kBAAA;AAUF;;AAPA;EACE,UAAA;EACA,kBAAA;AAUF;;AAPA;EACE,uBAAA;AAUF;;AANA;EAGE,wBAAA;AAOF;;AAJA;EACE,6BAAA;AAOF;;AAJA;EACE,qBAAA;AAOF;;AAJA;EACE,sBAAA;AAOF;;AAJA;EACE,eAAA;AAOF;;AAJA;EACE,6BAAA;AAOF;;AAJA;EACE,sBAAA;EACA,8BAAA;EACA,+BAAA;EACA,eAAA;EACA,6CAAA;AAOF;;AAJA;EACE,gCAAA;AAOF;;AAJA;EACE,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AAOF;;AAJA;EACE,2BAAA;AAOF;;AAJA;EACE,0BAAA;EACA,mDAAA;EACA,8BAAA;EACA,+BAAA;EACA,YAAA;EACA,kBAAA;AAOF;;AAJA;EACE,4BAAA;EACA,2BAAA;AAOF;;AAJA;EACE,gBAAA;AAOF;;AAJA;EACE,aAAA;EACA,yBAAA;AAOF;;AAJA;EACE,qBAAA;AAOF;;AAJA;EACE,cAAA;EACA,mDAAA;EACA,WAAA;EACA,mBAAA;AAOF;;AAJA;EACE,2BAAA;EACA,2BAAA;EACA,2BAAA;AAOF;;AAJA;EACE,0BAAA;EACA,6BAAA;AAOF;;AAJC;EACC,YAAA,EAAA,qCAAA;EACA,iBAAA;EACA,YAAA;AAOF;;AAJA,iEAAA;AACA;EACE,sBAAA,EAAA,0BAAA;EACA,sBAAA,EAAA,8BAAA;EACA,oBAAA;AAOF;;AAHA;EACE,gBAAA;EACA,eAAA;AAMF;;AAFA;EACE,WAAA;EACA,gBAAA;AAKF;;AAFA;EACE,4BAAA;EACA,0BAAA;EACA,uBAAA;AAKF;;AAFA;EACE,YAAA;AAKF;;AAFA;EACE,4BAAA;AAKF;;AAFA;EAEI,eAAA;EACA,2BAAA;EACA,8BAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACJ,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAIA;;AAAA;EACE,0BAAA;EACA,uBAAA;AAGF;;AAAA;EACE,cAAA;EACA,kBAAA;AAGF;;AADA;EACE,iBAAA;EAAkB,0BAAA;EAA2B,QAAA;EAC7C,0BAAA;AAMF;;AAJA;EACE,YAAA;AAOF;;AALA;EACE,kBAAA;AAQF;;AALE;EACE,kCAAA;AAQJ;AAPE;EACE,uBAAA;AASJ;AAPE;EACE,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,sBAAA;EACA,kCAAA;AASJ;AARI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;AAUN;AAPI;EACE,kCAAA;EACA,yBAAA;AASN;AARM;EACA,yBAAA;AAUN;AAPI;EACE,oCAAA;EACF,WAAA;EACA,yBAAA;AASJ;AALA;EACE,uBAAA;AAOF;AANE;EACE,gBAAA;EACA,kBAAA;AAQJ;;AAHM;EACF,kCAAA;AAMJ;AALE;EACE,uBAAA;EACA,oCAAA;AAOJ;AALE;EACE,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,sBAAA;EACA,0CAAA;EACA,+BAAA;AAOJ;AANQ;EACF,kBAAA;EACA,UAAA;EACA,YAAA;AAQN;AAJI;EACE,kCAAA;EACA,yBAAA;AAMN;AALM;EACA,yBAAA;AAON;AAJI;EACE,oCAAA;EACF,WAAA;EACA,yBAAA;AAMJ;AAFI;EACF,uBAAA;AAIF;AAHE;EACE,gBAAA;EACA,kBAAA;AAKJ;;AAAM;EACF,kCAAA;AAGJ;AAFE;EACE,uBAAA;EACA,oCAAA;AAIJ;AAFE;EACE,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,sBAAA;EACA,0CAAA;EACA,+BAAA;AAIJ;AAHI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;AAKN;AAFI;EACE,kCAAA;EACA,yBAAA;AAIN;AAHM;EACA,yBAAA;AAKN;AAFI;EACE,oCAAA;EACF,WAAA;EACA,yBAAA;AAIJ;AAAI;EACF,uBAAA;AAEF;AADE;EACE,gBAAA;EACA,kBAAA;AAGJ;;AAEE;EACE,0BAAA;EACA,mBAAA;EACA,yBAAA;AACJ;;AACE;EACE,0BAAA;EACA,mBAAA;EACA,yBAAA;AAEJ;;AAAA;EAIE,2BAAA;EACA,2BAAA;AAAF;AAJE;EACE,2BAAA;AAMJ;;AAAA,mGAAA;AACA;EACE,2BAAA;AAGF;;AADA;EACE,sBAAA;EACA,6BAAA;EACA,sBAAA;AAIF;AAHE;EACE,kCAAA;AAKJ;AAJI;EACE,wBAAA;AAMN;AAJI;EACE,kCAAA;AAMN;AAJI;EACE,2BAAA;AAMN;AALM;EACA,4BAAA;EACA,8BAAA;EACA,2BAAA;AAON;AANM;EACE,0BAAA;EACA,YAAA;EACA,0BAAA;EACA,gBAAA;AAQR;AANM;EACE,uBAAA;EACA,sBAAA;EACA,6BAAA;AAQR;AAPQ;EACE,0BAAA;AASV;AAFI;EACA,kCAAA;AAIJ;AAHI;EACE,wBAAA;AAKN;AAHI;EACE,kCAAA;AAKN;AAHI;EACE,wBAAA;EACA,2BAAA;AAKN;AAJM;EACE,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;AAMR;AAJM;EACE,uBAAA;EACA,sBAAA;EACA,6BAAA;AAMR;AALQ;EACE,0BAAA;AAOV;AAFI;EACE,wBAAA;AAIN;AADE;EACE,wBAAA;AAGJ;;AAAA;EAEE,SAAA;AAEF;AADE;EACE,WAAA;AAGJ;;AAAA;EACE,cAAA;EACE,eAAA;EACA,WAAA;EACA,4BAAA;EACA,YAAA;EACA,qBAAA;AAGJ","sourcesContent":["@import \"../../variables.scss\";\r\n@import 'src/assets/fonts/Nunito/Nunito.css';\r\n\r\n.Case_360_view {\r\n  font-size: 12px !important;\r\n  font-family: montserrat !important;\r\n}\r\n.labCase_360_view {\r\n  font-family: Nunito, sans-serif !important;\r\n}\r\n\r\n.Case_360_view .eventselecttypeControl {\r\n  width: 96%;\r\n  border: none;\r\n  padding-block: 2px;\r\n  height: 28px;\r\n  margin-left: 8px; /* Adjust as needed to provide space between input and buttons */\r\n  padding-right: 23px !important;\r\n}\r\n.Case_360_view .blod_text {\r\n  color: #007887;\r\n}\r\n\r\n.Case_360_view .parentsearchdiv{\r\n  background-color: white;\r\n  height: 76px;\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n}\r\n\r\n.Case_360_view .date_control_style {\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%),\r\n    0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  width: 78%;\r\n  float: left;\r\n  min-height: 8vh !important;\r\n  max-height: 8vh !important;\r\n  overflow-x: hidden !important;\r\n  overflow-y: auto !important;\r\n  background-color: white !important; \r\n  top: 10px;\r\n}\r\n\r\n.Case_360_view .case360inputfield{\r\n position: relative !important;\r\n bottom: 7px !important;\r\n padding-top: 5px;\r\n}\r\n\r\n.Case_360_view .case360button{\r\n  padding-top: 11px;\r\n}\r\n\r\n.Case_360_view .case360userguidance{\r\n  margin-top: 4%;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  width: 1359px;\r\n}\r\n\r\n.Case_360_view .close_icon {\r\n  position: absolute;\r\n  top: 27%;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  color: grey;\r\n  font-weight: 600;\r\n  right: 0;\r\n}\r\n.Case_360_view .help-main-title {\r\n  font-size: 17px;\r\n  text-align: center;\r\n}\r\n.Case_360_view .case_details {\r\n  text-align: center;\r\n  position: relative;\r\n  width: 16%;\r\n  padding-inline: 12px;\r\n  color: #001c3b;\r\n}\r\n.Case_360_view .case_details_title {\r\n  width: 100%;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow-x: hidden;\r\n}\r\n.Case_360_view .caseHeaderBorder {\r\n  height: 14px;\r\n  width: 2px;\r\n  background-color: #17a0b4 !important;\r\n  position: absolute;\r\n  top: 14%;\r\n  right: 0%;\r\n}\r\n.Case_360_view .case_info {\r\n  background: #e2e2e2 0% 0% no-repeat padding-box;\r\n  padding-inline: 8px;\r\n}\r\n::ng-deep.Case_360_view .case_tabs {\r\n  .mat-tab-header {\r\n    height: 33px;\r\n  }\r\n  .mat-tab-label {\r\n    height: 31px !important;\r\n    text-transform: uppercase;\r\n  }\r\n  .mat-tab-group.mat-primary .mat-ink-bar,\r\n  .mat-tab-nav-bar.mat-primary .mat-ink-bar {\r\n    margin-left: unset !important;\r\n  }\r\n\r\n  .mat-tab-label-container {\r\n    background-color: transparent;\r\n    border-bottom: 1px solid #17a0b4;\r\n  }\r\n  .mat-tab-group.mat-primary .mat-ink-bar {\r\n    background-color: #376b96 !important;\r\n    height: 2px !important;\r\n  }\r\n  .mat-tab-label .mat-tab-label-content {\r\n    font-size: 10px !important;\r\n    font-weight: 600 !important;\r\n    font-family: montserrat !important;\r\n  }\r\n\r\n  .mat-tab-label.mat-ripple.mat-tab-label-active {\r\n    color: #376b96 !important;\r\n    background-color: white !important;\r\n    opacity: unset !important;\r\n  }\r\n}\r\n::ng-deep.Case_360_view .labcase_tabs {\r\n  .mat-tab-header {\r\n    height: 33px;\r\n  }\r\n  .mat-tab-label {\r\n    height: 31px !important;\r\n    text-transform: uppercase;\r\n  }\r\n  .mat-tab-group.mat-primary .mat-ink-bar,\r\n  .mat-tab-nav-bar.mat-primary .mat-ink-bar {\r\n    margin-left: unset !important;\r\n  }\r\n\r\n  .mat-tab-label-container {\r\n    background-color: transparent;\r\n    border-bottom: 1px solid #17a0b4;\r\n  }\r\n  .mat-tab-group.mat-primary .mat-ink-bar {\r\n    background-color: #376b96 !important;\r\n    height: 2px !important;\r\n  }\r\n  .mat-tab-label .mat-tab-label-content {\r\n    font-size: 10px !important;\r\n    font-weight: 600 !important;\r\n    font-family:  Nunito, sans-serif !important;\r\n  }\r\n\r\n  .mat-tab-label.mat-ripple.mat-tab-label-active {\r\n    color: #376b96 !important;\r\n    background-color: white !important;\r\n    opacity: unset !important;\r\n  }\r\n}\r\n\r\n.Case_360_view .active_img {\r\n  display: none;\r\n}\r\n.Case_360_view .inactive_img {\r\n  display: block;\r\n  margin-right: 9px;\r\n  position: relative;\r\n  top: -2px;\r\n}\r\n.Case_360_view .active_img_inbound {\r\n  display: none;\r\n}\r\n.Case_360_view .inactive_img_inbound {\r\n  display: block;\r\n  margin-right: 11px;\r\n  position: relative;\r\n  top: -2px;\r\n}\r\n::ng-deep.Case_360_view .event_card {\r\n  height: 75vh;\r\n  border-right: 3px solid #007887;\r\n  .header {\r\n    height: 50px;\r\n    background: #f2f2f2 0% 0% no-repeat padding-box;\r\n    .search_control {\r\n      width: 90%;\r\n      height: 28px;\r\n      margin: auto;\r\n      border-radius: 5px;\r\n      border: 1px solid #001c3b;\r\n      background-color: white;\r\n      .search_icon {\r\n        position: relative;\r\n        left: 2%;\r\n        top: 10%;\r\n      }\r\n      .input_control {\r\n        width: 93%;\r\n        border: none;\r\n        background-color: transparent;\r\n        position: relative;\r\n        left: 3%;\r\n        top: 13%;\r\n      }\r\n    }\r\n  }\r\n\r\n  .Case_360_view .mat-tab-label {\r\n    height: 37px !important;\r\n    flex: 1 !important;\r\n    text-transform: uppercase;\r\n  }\r\n  .Case_360_view .mat-tab-group.mat-primary .mat-ink-bar,\r\n  .mat-tab-nav-bar.mat-primary .mat-ink-bar {\r\n    margin-left: unset !important;\r\n  }\r\n\r\n  .Case_360_view .mat-tab-label-container {\r\n    background-color: #f3f3f3 !important;\r\n  }\r\n  .Case_360_view .mat-tab-group.mat-primary .mat-ink-bar {\r\n    background-color: #17a0b4 !important;\r\n    height: 3px !important;\r\n  }\r\n  .Case_360_view .mat-tab-label .mat-tab-label-content {\r\n    font-size: 12px !important;\r\n    font-weight: 600 !important;\r\n  }\r\n\r\n  .Case_360_view .mat-tab-label.mat-ripple.mat-tab-label-active {\r\n    color: #17a0b4 !important;\r\n    background-color: white !important;\r\n    opacity: unset !important;\r\n    .outbound_style {\r\n      .active_img {\r\n        display: block !important;\r\n        margin-right: 9px;\r\n        position: relative;\r\n        top: -2px;\r\n      }\r\n      .inactive_img {\r\n        display: none !important;\r\n      }\r\n    }\r\n    .inbound_style {\r\n      .active_img_inbound {\r\n        display: block !important;\r\n        margin-right: 11px;\r\n        position: relative;\r\n        top: -2px;\r\n      }\r\n      .inactive_img_inbound {\r\n        display: none !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n.Case_360_view .event_card_info {\r\n  height: 75vh;\r\n  border-left: 3px solid #007887;\r\n  margin-left: 2px;\r\n  .header {\r\n    height: 50px;\r\n    background: #f2f2f2 0% 0% no-repeat padding-box;\r\n  }\r\n}\r\n.Case_360_view .Event_lables {\r\n  height: 60px;\r\n  background: #e5f1f3;\r\n  padding-inline: 13px;\r\n}\r\n.Case_360_view .eventtype_lables {\r\n  background-color: white;\r\n  padding-inline: 4%;\r\n  padding-block: 0px;\r\n  margin: 8px;\r\n  display: inline-block;\r\n  border-radius: 50pc;\r\n  cursor: pointer;\r\n  box-shadow: 1px 1px 4px 0px grey;\r\n}\r\n\r\n.Case_360_view .eventtype_lables_active {\r\n  background-color: #007887;\r\n  padding-inline: 4%;\r\n  padding-block: 0px;\r\n  margin: 8px;\r\n  display: inline-block;\r\n  border-radius: 50pc;\r\n  cursor: pointer;\r\n  color: white;\r\n  box-shadow: 1px 1px 4px 0px grey;\r\n}\r\n\r\n\r\n.Case_360_view .messageInfo {\r\n  border-left: 4px solid green;\r\n  box-shadow: 1px 1px 6px 0px grey;\r\n  border-radius: 5px;\r\n  padding-inline: 6px;\r\n  padding-block: 3px;\r\n}\r\n\r\n.Case_360_view .cardActive {\r\n  background-color: #cce4e7;\r\n}\r\n\r\n.Case_360_view .listview {\r\n  padding-inline: 19px;\r\n  max-height: 53vh;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.Case_360_view .view_file_icon {\r\n  width: 19px !important;\r\n  float: left;\r\n  position: relative;\r\n  top: -3px;\r\n  left: 6px;\r\n}\r\n\r\n.Case_360_view .barline {\r\n  height: 1px;\r\n  background-color: black;\r\n  margin-inline: 13px;\r\n}\r\n\r\n::ng-deep.Case_360_view.message_menu.mat-menu-panel {\r\n  button.mat-menu-item {\r\n    height: 26px !important;\r\n    line-height: 26px !important;\r\n    text-align: center !important;\r\n    color: #179fb3 !important;\r\n    font-size: 13px !important;\r\n  }\r\n}\r\n\r\n.Case_360_view .lables_status {\r\n  border-radius: 4px;\r\n  padding-block: 3px;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n}\r\n\r\n::ng-deep.Case_360_view .viewstages .modal-dialog {\r\n  max-width: 97% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.Case_360_view .viewstages {\r\n  top: 4% !important;\r\n}\r\n\r\n.Case_360_view .inputContainer {\r\n  height: 81vh;\r\n  background-color: #f3f3f3;\r\n  border: 1px solid #707070;\r\n  .header {\r\n    background-color: #d1d1d1;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    border-bottom: 1px solid #707070;\r\n  }\r\n}\r\n.Case_360_view .outputContainer {\r\n  height: 81vh;\r\n  background-color: #f3f3f3;\r\n  border: 1px solid #707070;\r\n  .header {\r\n    background-color: #d1d1d1;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    border-bottom: 1px solid #707070;\r\n  }\r\n}\r\n\r\n.Case_360_view .icons_list_style {\r\n  width: 5%;\r\n  padding-bottom: 8px;\r\n  text-align: center;\r\n  margin-inline: 3px;\r\n}\r\n.Case_360_view .icons_list_style_active {\r\n  border-bottom: 3px solid #00bcd4;\r\n  width: 5%;\r\n  padding-bottom: 8px;\r\n  text-align: center;\r\n  margin-inline: 3px;\r\n}\r\n\r\n.Case_360_view .case_info_container {\r\n  border: 1.5px solid #17a0b4;\r\n  padding: 5px;\r\n  position: relative;\r\n  margin-block: 16px;\r\n}\r\n\r\n.Case_360_view .card_label_title {\r\n  background-color: #fbfbfb;\r\n  position: absolute;\r\n  padding-inline: 5px;\r\n  font-size: 10px;\r\n  top: -9px;\r\n  color: #001c3b;\r\n  font-weight: 600;\r\n}\r\n\r\n.Case_360_view .lables_style {\r\n  font-size: 10px;\r\n  color: black;\r\n}\r\n.Case_360_view .value_style {\r\n  font-weight: 600;\r\n  font-size: 10px;\r\n  color: #17a0b4 !important;\r\n}\r\n\r\n.Case_360_view .case_details_info {\r\n  height: 17.5vh;\r\n}\r\n.Case_360_view .dates_info {\r\n  height: 24vh;\r\n}\r\n.Case_360_view .case_info_data {\r\n  height: 26vh;\r\n}\r\n\r\n.Case_360_view .case_patient_info {\r\n  height: 37vh;\r\n}\r\n.Case_360_view .case_Information_info {\r\n  height: 30vh;\r\n}\r\n.Case_360_view .case_Contact_info {\r\n  height: 29vh;\r\n}\r\n.Case_360_view .case_Insurance_info {\r\n  height: 16vh;\r\n}\r\n.Case_360_view .case_DX_reports {\r\n  height: 11vh;\r\n}\r\n.Case_360_view .case_send_in_details {\r\n  height: 11vh;\r\n}\r\n.Case_360_view .case_referring_details {\r\n  height: 14vh;\r\n}\r\n.Case_360_view .case_laboratory_details {\r\n  height: 17vh;\r\n}\r\n.Case_360_view .case_orderingfacility_details {\r\n  height: 17vh;\r\n}\r\n.Case_360_view .case_send_out_details {\r\n  height: 11vh;\r\n}\r\n.Case_360_view .sec_date {\r\n  font-size: 10px;\r\n}\r\n.Case_360_view .pt_date {\r\n  font-size: 9px;\r\n  margin-left: 3px;\r\n}\r\n\r\n.Case_360_view .more_info {\r\n  color: blue;\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n}\r\n\r\n.Case_360_view .orderedDate {\r\n  color: #827ec4 !important;\r\n}\r\n.Case_360_view .collectionDate {\r\n  color: #80a8d0 !important;\r\n}\r\n.receivedDate {\r\n  color: #278c7d !important;\r\n}\r\n.signedoutDate {\r\n  color: #d17800 !important;\r\n}\r\n.reportDate {\r\n  color: #c02755 !important;\r\n}\r\n.sendinDate {\r\n  color: #443ea7 !important;\r\n}\r\n.sendoutDate {\r\n  color: #3575b5 !important;\r\n}\r\n\r\n.insurance_more_info {\r\n  height: 62.5vh;\r\n}\r\n\r\n.text_elip {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.flag_class {\r\n  background-color: #e8e8e5;\r\n  min-width: auto;\r\n  border-radius: 3px;\r\n  color: #001c3b;\r\n  font-size: 11px;\r\n  min-width: 164px !important;\r\n  padding-inline: 6px;\r\n  padding-block: 2px;\r\n  margin: 3px;\r\n  max-width: 320px;\r\n}\r\n\r\n.no_data {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  color: #001C3B;\r\n}\r\n\r\n.search_control {\r\n  width: 61% !important;\r\n}\r\n.demo_text {\r\n  font-size: 15px;\r\n}\r\n\r\n.box_sizing_search {\r\n  box-sizing: content-box;\r\n  width: 98%;\r\n}\r\n\r\n.casecard {\r\n  background-color: white;\r\n  box-shadow: 1px 1px 4px 0px #342e2ea8;\r\n  padding-inline: 5px;\r\n  justify-content: space-around;\r\n  margin-block: 6px;\r\n  border-radius: 2px;\r\n  margin-inline: 10px;\r\n  padding-block: 7px;\r\n  cursor: pointer;\r\n}\r\n\r\n.chevronleftbtnact {\r\n  background-color: green;\r\n  color: white;\r\n  cursor: pointer;\r\n}\r\n.chevronleftbtninact {\r\n  background-color: red;\r\n  color: white;\r\n  margin-left: 1%;\r\n}\r\n\r\n.chevronleft {\r\n  margin: auto;\r\n  justify-content: center;\r\n  display: flex;\r\n}\r\n\r\n//display info\r\n\r\n.pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.time-ago {\r\n  font-size: 0.7rem;\r\n  text-align: right;\r\n  top: -2px;\r\n  right: 45px;\r\n}\r\n\r\n.advance-search {\r\n  margin-top: 20px;\r\n  padding-left: 0px;\r\n}\r\n\r\n.button-go {\r\n  display: block !important;\r\n  margin-top: 11px !important;\r\n}\r\n\r\n.spinner-border {\r\n  display: inline-block;\r\n  padding-left: 600px;\r\n  margin-top: 200px;\r\n  border-left-width: 100px;\r\n  margin-left: 100px;\r\n  margin-right: 100px;\r\n  margin-bottom: 200px;\r\n  padding-right: 500px;\r\n}\r\n\r\n.mat-tab-group.mat-primary .mat-ink-bar,\r\n.mat-tab-nav-bar.mat-primary .mat-ink-bar {\r\n  background-color: #00bcd4 !important;\r\n}\r\n\r\n.card-headers {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  width: 99%;\r\n  height: 25px;\r\n  display: flex;\r\n}\r\n\r\n.modal-popup-displaytext {\r\n  padding-left: 12px;\r\n}\r\n\r\n.modal-popup-header {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  padding-left: 25px;\r\n}\r\n\r\n.modal-popup-content {\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n}\r\n\r\n.card-header-text {\r\n  font-size: 13px;\r\n  color: slateblue;\r\n}\r\n\r\n.other-info {\r\n  height: 238px !important;\r\n}\r\n\r\n.close-button-icon {\r\n  padding-right: 10px;\r\n  padding-top: 10px;\r\n}\r\n\r\n.filter-key {\r\n  padding-bottom: 0.5rem;\r\n}\r\n\r\n.filter-values {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.filter-box {\r\n  box-shadow: 0 0 0px rgba(0, 0, 0, 0);\r\n  height: calc(100vh - 225px);\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.filter-parent-height {\r\n  background: #ffffff;\r\n  padding: 0;\r\n}\r\n\r\n.box-body {\r\n  padding: 0.5rem !important;\r\n}\r\n\r\n.scroll-height {\r\n  overflow: auto;\r\n  padding-right: 15px;\r\n}\r\n\r\n.box-header {\r\n  padding-bottom: 0 !important;\r\n}\r\n\r\n.show {\r\n  display: block;\r\n}\r\n\r\n.hidden {\r\n  display: none;\r\n}\r\n\r\n.Case_360_view .dropdown-menu a:hover {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.Case_360_view .dropdown-menu a {\r\n  padding: 0;\r\n  color: black;\r\n}\r\n\r\n.noDataFound {\r\n  .col-4 {\r\n    height: 25px;\r\n  }\r\n\r\n  .col-8 {\r\n    height: 0;\r\n  }\r\n\r\n  .message {\r\n    display: flex;\r\n  }\r\n\r\n  .onload-t {\r\n    color: #000000e0;\r\n  }\r\n\r\n  .onload-b {\r\n    margin-top: 15px;\r\n    color: #756d6d;\r\n  }\r\n}\r\n\r\n.advresultmsg {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.panel-right-filter {\r\n  position: inherit;\r\n  right: 0px;\r\n  z-index: 100;\r\n  height: auto;\r\n}\r\n\r\n.a-s-f {\r\n  display: flex;\r\n  padding-left: 0.7rem;\r\n}\r\n\r\n.chip-list {\r\n  padding: 0.2rem 0.2rem 0 0.5rem;\r\n}\r\n\r\n.Case_360_view .chip {\r\n  border: 1px solid #0079b8;\r\n  background-color: #ffffff;\r\n  font-size: 0.7rem;\r\n  font-weight: 400;\r\n  line-height: 0.458333rem;\r\n  align-items: center;\r\n  min-height: 1.25rem;\r\n  margin: 0 0.25rem 0 0 !important;\r\n  white-space: nowrap;\r\n\r\n  .chip-icon {\r\n    color: rgb(13, 135, 225) !important;\r\n    opacity: 1.4 !important;\r\n    margin: 0 -0.375rem 0 0.25rem !important;\r\n  }\r\n}\r\n\r\n.mat-chip.mat-standard-chip::after {\r\n  background: #0d87e1;\r\n}\r\n\r\n.drop-down-caret::before {\r\n  content: \"\\f0d7\";\r\n}\r\n\r\n.drop-down-caret.collapsed::before {\r\n  content: \"\\f0da\";\r\n}\r\n\r\n.help_label {\r\n  display: block;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.help-inline-wrap {\r\n  padding: 0px 40px 0px 40px !important;\r\n}\r\n\r\n.help-headline {\r\n  text-align: center;\r\n  line-height: 1.2;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.help-main-title {\r\n  font-size: 24px;\r\n}\r\n\r\n.help-sub-title {\r\n  font-size: 18px;\r\n}\r\n\r\n.deployment-title {\r\n  font-size: 18px;\r\n}\r\n\r\n.pdf-align {\r\n  color: #00bcd4;\r\n  font-size: 22px;\r\n}\r\n\r\n.logo-align {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-around;\r\n}\r\n\r\n.icon-size {\r\n  width: 25px;\r\n  height: auto;\r\n  opacity: 0.5;\r\n  cursor: pointer;\r\n}\r\n\r\n.list-icon-remove {\r\n  list-style-type: none;\r\n}\r\n\r\n.border-bottom {\r\n  border-bottom: 1px solid #e5e1e1;\r\n}\r\n\r\n.icon-size:hover {\r\n  font-weight: 600;\r\n}\r\n\r\n.dropdown-menu {\r\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\r\n  font-size: 12px;\r\n}\r\n\r\n.dropdown-content:after {\r\n  content: \"\";\r\n  /* Required to display content */\r\n  position: absolute;\r\n  /* Sets the position absolute to the top div */\r\n  top: 0;\r\n  left: 5%;\r\n  margin-top: -10px;\r\n  width: 0;\r\n  z-index: 1;\r\n  height: 0;\r\n  border-bottom: solid 10px #fff;\r\n  /* Creates the arrow pointing up, to change to a notch instead user border-top */\r\n  border-left: solid 10px transparent;\r\n  /* Creates triangle effect */\r\n  border-right: solid 10px transparent;\r\n  /* Creates triangle effect */\r\n}\r\n\r\n/* Style the links inside the dropdown */\r\n.dropdown-content a {\r\n  float: none;\r\n  color: #333;\r\n  text-decoration: none;\r\n  display: block;\r\n  text-align: left;\r\n}\r\n\r\n#caseAssign .modal-footer {\r\n  justify-content: center !important;\r\n}\r\n\r\n::ng-deep .popup-dropdown .mat-form-field-infix {\r\n  width: 415px !important;\r\n  height: 45px !important;\r\n}\r\n\r\n.dropdown-item:hover {\r\n  font-weight: 600 !important;\r\n}\r\n\r\nimg.dropdown-item:hover {\r\n  opacity: 0.9;\r\n}\r\n\r\n::ng-deep\r\n  .assign-wrap\r\n  .mat-form-field-appearance-outline\r\n  .mat-form-field-infix {\r\n  padding: 0.2em 0 0.6em 0 !important;\r\n}\r\n\r\n#caseAssign .modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 5px !important;\r\n  border-bottom: 1px solid #eceeef;\r\n  background: #00bcd4 !important;\r\n  color: #fff !important;\r\n  border-radius: 10px 10px 0px 0px !important;\r\n}\r\n\r\n#caseAssign .modal-content {\r\n  border-radius: 10px !important;\r\n}\r\n\r\n#caseAssign .modal-title {\r\n  font-size: 20px !important;\r\n  font-weight: normal !important;\r\n}\r\n\r\n#caseAssign button.close {\r\n  color: #fff !important;\r\n  font-weight: normal !important;\r\n}\r\n\r\n.Case_360_view .display-text {\r\n  height: 20px;\r\n}\r\n\r\n.Case_360_view .date-align {\r\n  height: auto;\r\n}\r\n\r\n.Case_360_view .search-align {\r\n  float: left;\r\n  padding-left: 10px !important;\r\n}\r\n\r\n.Case_360_view .icon-wrap {\r\n  margin-top: 6px;\r\n}\r\n\r\n.Case_360_view .icon-color {\r\n  color: grey;\r\n}\r\n\r\n.Case_360_view .icon-handler {\r\n  margin-left: 15px;\r\n}\r\n\r\n.Case_360_view .drop-down-wrap {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.Case_360_view .label-wrap {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.Case_360_view .input-wrap {\r\n  width: 90%;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.Case_360_view .assign-icon {\r\n  opacity: 0.6 !important;\r\n}\r\n\r\n// custom case assignment action popup\r\n::ng-deep.Case_360_view .drop-down-wrap\r\n  .mat-form-field-appearance-outline\r\n  .mat-select-arrow-wrapper {\r\n  display: none !important;\r\n}\r\n\r\n::ng-deep.Case_360_view  .case-assign-action .modal-content {\r\n  margin: 140px auto !important;\r\n}\r\n\r\n.Case_360_view .drop-down-wrap input.input-width {\r\n  width: 90% !important;\r\n}\r\n\r\n.Case_360_view .modal-height {\r\n  margin: 0px !important;\r\n}\r\n\r\n.Case_360_view .desc-font {\r\n  font-size: 10px;\r\n}\r\n\r\n.Case_360_view .dropdown-border .form-control {\r\n  border-radius: 5px !important;\r\n}\r\n\r\n.Case_360_view .entitycard-wrap {\r\n  color: #000 !important;\r\n  border-bottom-left-radius: 5px;\r\n  border-bottom-right-radius: 5px;\r\n  font-size: 12px;\r\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.Case_360_view .border-help {\r\n  border-bottom: 1px solid #bebdbd;\r\n}\r\n\r\n.Case_360_view .deployment-align {\r\n  border-right: 1px solid #bebdbd;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: left;\r\n}\r\n\r\n::ng-deep.Case_360_view  .wj-cell.wj-align-right:nth-child(5) {\r\n  text-align: left !important;\r\n}\r\n\r\n.Case_360_view .deploy-table {\r\n  font-size: 12px !important;\r\n  border: 1px solid #70707080;\r\n  border-bottom-left-radius: 5px;\r\n  border-bottom-right-radius: 5px;\r\n  height:auto;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.Case_360_view .header-border {\r\n  border-top-right-radius: 5px;\r\n  border-top-left-radius: 5px;\r\n}\r\n\r\n.Case_360_view .font-bold {\r\n  font-weight: 600;\r\n}\r\n\r\n.Case_360_view .sub-search {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.Case_360_view .word-break {\r\n  word-break: break-all;\r\n}\r\n\r\n.Case_360_view .title-wraps {\r\n  display: table;\r\n  border: 1px solid #70707080;\r\n  color: #fff;\r\n  background: #00bbd3;\r\n}\r\n\r\n::ng-deep.Case_360_view .mat-menu-panel {\r\n  max-width: 450px !important;\r\n  min-width: 400px !important;\r\n  overflow: hidden !important;\r\n}\r\n\r\n::ng-deep.Case_360_view .mat-menu-content:not(:empty){\r\n  padding-top: 0% !important;\r\n  padding-bottom: 0% !important;\r\n}\r\n\r\n label{\r\n  width: 112px; /* Set a fixed width for the labels */\r\n  margin-right: 5px;\r\n  height: 20px;\r\n}\r\n\r\n/* Optional: Adjust the appearance of the autocomplete dropdown */\r\n::ng-deep.Case_360_view .mat-autocomplete-panel {\r\n  border: 1px solid #ccc; /* Dropdown border color */\r\n  background-color: #fff; /* Dropdown background color */\r\n  top: 100% !important;\r\n}\r\n\r\n\r\n::ng-deep.Case_360_view .form-style{\r\n  overflow: hidden;\r\n  font-size: 11px;\r\n  \r\n}\r\n\r\n::ng-deep.Case_360_view .mat-chip.mat-standard-chip{\r\n  height: 1px;\r\n  min-height: 20px;\r\n}\r\n\r\n::ng-deep.Case_360_view .autocomplete-container .input-container input{\r\n  padding-right: 5% !important;\r\n  font-size: 11px !important;\r\n  height: 33px !important;\r\n}\r\n\r\n::ng-deep.Case_360_view .form-control{\r\n  padding: 4px;\r\n}\r\n\r\n::ng-deep.Case_360_view .mat-form-field-infix {\r\n  display: contents !important;\r\n}\r\n\r\n.Case_360_view .customchip\r\n  {\r\n    font-size: 12px;\r\n    min-height: 21px !important;\r\n    padding-inline: 8px !important;\r\n    float: left !important;\r\n    margin-inline-start: 12px; \r\n    font-size: 12px;\r\n    padding: 2px;\r\n    display: flex;\r\nflex-wrap: wrap;\r\nalign-items: center;\r\nmargin-left: 2px;\r\nmargin-top: 7px\r\n  }\r\n\r\n\r\n::ng-deep.Case_360_view .mat-button, .mat-flat-button, .mat-icon-button, .mat-stroked-button {\r\n  min-width: 25px !important;\r\n  padding: 1px !important;\r\n}\r\n\r\n.Case_360_view .case360asterisk{\r\n  font-size: 6px;\r\n  position: absolute;\r\n}\r\n.Case_360_view .filterbtn{\r\n  line-height: 20px;font-size: 16px !important;top: 0px;\r\n  min-width: 25px !important;\r\n}\r\n.Case_360_view .userguidancemaindiv{\r\n  height: 69vh;\r\n}\r\n.Case_360_view .searchformbtns{\r\n  padding-left: 18px;\r\n}\r\n::ng-deep.mat_tab_styles_case360 {\r\n  .mat-mdc-tab-label-container {\r\n    background-color: white !important;\r\n  .mat-mdc-tab-labels {\r\n    height: 37px !important;\r\n  }\r\n  .mat-mdc-tab{\r\n    font-weight: 600;\r\n    font-size: 12px !important;\r\n    padding-bottom: 8px;\r\n    letter-spacing:normal;\r\n    font-family: montserrat !important; \r\n    .mdc-tab__text-label{\r\n      position: relative;\r\n      bottom: 7%;\r\n      color: black;\r\n    }\r\n  }\r\n    .mat-mdc-tab.mdc-tab--active{\r\n      background-color: white !important;\r\n      opacity: unset !important;\r\n      .mdc-tab__text-label {\r\n      color:  #17a0b4 !important;\r\n      \r\n    }\r\n    .mdc-tab-indicator .mdc-tab-indicator__content {\r\n      background-color: #17a0b4 !important;\r\n    height: 7px;\r\n    border-color: transparent;\r\n    }\r\n  }\r\n}\r\n.mat-mdc-tab-body-wrapper {\r\n  height: 70vh !important;\r\n  .mat-mdc-tab-body-content {\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n  }\r\n}\r\n  }\r\n  ::ng-deep.mat_tab_styles_labcase360 {\r\n      .mat-mdc-tab-label-container {\r\n    background-color: white !important;\r\n  .mat-mdc-tab-labels {\r\n    height: 37px !important;\r\n    background-color: #d2d2d2 !important;\r\n  }\r\n  .mat-mdc-tab{\r\n    font-weight: 600;\r\n    font-size: 12px !important;\r\n    padding-bottom: 8px;\r\n    letter-spacing:normal;\r\n    font-family: Nunito, sans-serif !important;\r\n    border-right: 1px solid #ababab;\r\n        .mdc-tab__text-label{\r\n      position: relative;\r\n      bottom: 7%;\r\n      color: black;\r\n    }\r\n  }\r\n\r\n    .mat-mdc-tab.mdc-tab--active{\r\n      background-color: white !important;\r\n      opacity: unset !important;\r\n      .mdc-tab__text-label {\r\n      color:  #17a0b4 !important;\r\n      \r\n    }\r\n    .mdc-tab-indicator .mdc-tab-indicator__content {\r\n      background-color: #17a0b4 !important;\r\n    height: 7px;\r\n    border-color: transparent;\r\n    }\r\n  }\r\n}\r\n    .mat-mdc-tab-body-wrapper {\r\n  height: 83vh !important;\r\n  .mat-mdc-tab-body-content {\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n  }\r\n}\r\n  }\r\n    ::ng-deep.mat_tab_styles_jupcase360 {\r\n      .mat-mdc-tab-label-container {\r\n    background-color: white !important;\r\n  .mat-mdc-tab-labels {\r\n    height: 37px !important;\r\n    background-color: #d2d2d2 !important;\r\n  }\r\n  .mat-mdc-tab{\r\n    font-weight: 600;\r\n    font-size: 12px !important;\r\n    padding-bottom: 8px;\r\n    letter-spacing:normal;\r\n    font-family: Nunito, sans-serif !important;\r\n    border-right: 1px solid #ababab;\r\n    .mdc-tab__text-label{\r\n      position: relative;\r\n      bottom: 7%;\r\n      color: black;\r\n    }\r\n  }\r\n    .mat-mdc-tab.mdc-tab--active{\r\n      background-color: white !important;\r\n      opacity: unset !important;\r\n      .mdc-tab__text-label {\r\n      color:  #17a0b4 !important;\r\n      \r\n    }\r\n    .mdc-tab-indicator .mdc-tab-indicator__content {\r\n      background-color: #17a0b4 !important;\r\n    height: 7px;\r\n    border-color: transparent;\r\n    }\r\n  }\r\n}\r\n    .mat-mdc-tab-body-wrapper {\r\n  height: 78vh !important;\r\n  .mat-mdc-tab-body-content {\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n  }\r\n}\r\n  }\r\n\r\n  ::ng-deep.customautocomplete.mat-mdc-autocomplete-panel{\r\n    position: fixed !important;\r\n    top: 27% !important;\r\n    width: inherit !important;\r\n}\r\n  ::ng-deep.customautocompletedx.mat-mdc-autocomplete-panel{\r\n    position: fixed !important;\r\n    top: 19% !important;\r\n    width: inherit !important;\r\n}\r\n::ng-deep.custommatmenu.mat-mdc-menu-panel {\r\n  .mat-mdc-menu-content{\r\n    padding-block: 0 !important;\r\n  }\r\n  max-width: 450px !important;\r\n  min-width: 400px !important;\r\n}\r\n\r\n/* Case 360 Advance filter menu (Accession #, etc.) — override global flex-start on menu overlays */\r\n::ng-deep .cdk-overlay-pane:has(.custommatmenu.mat-mdc-menu-panel) {\r\n  align-self: auto !important;\r\n}\r\n::ng-deep.customstyle .mat-mdc-form-field{\r\n  width: 100% !important;\r\n  position: relative !important;\r\n  bottom: 8px !important;\r\n  .mat-mdc-text-field-wrapper{\r\n    background-color: white !important;\r\n    .mdc-line-ripple{\r\n      display: none !important;\r\n    }\r\n    .mat-mdc-form-field-focus-overlay{\r\n      background-color: white !important;\r\n    }\r\n    .mat-mdc-form-field-flex{ \r\n      min-height: 38px !important;\r\n      .mat-mdc-form-field-infix{\r\n      max-height: 250px !important;\r\n      padding-bottom: 0px !important;\r\n      min-height: 42px !important;\r\n      .mat-mdc-input-element{\r\n        font-size: 12px !important;\r\n        width: 150px ;\r\n        flex: 1 0 150px !important;\r\n        margin-left: 4px;\r\n      }\r\n      .mat-mdc-chip{\r\n        height: 24px !important;\r\n        float: left !important;\r\n        margin-inline: 1px !important;\r\n        .mdc-evolution-chip__text-label{\r\n          font-size: 12px !important;\r\n        }\r\n      }\r\n    }\r\n    }\r\n  }\r\n  .mat-focused {\r\n    .mat-mdc-text-field-wrapper{\r\n    background-color: white !important;\r\n    .mdc-line-ripple{\r\n      display: none !important;\r\n    }\r\n    .mat-mdc-form-field-focus-overlay{\r\n      background-color: white !important;\r\n    }\r\n    .mat-mdc-form-field-flex .mat-mdc-form-field-infix{\r\n      display: flex !important;\r\n      padding-top: 5px  !important;\r\n      .mat-mdc-input-element{\r\n        font-size: 12px !important;\r\n        width: 150px !important;\r\n        flex: 1 0 150px !important;\r\n        margin-left: 4px;\r\n      }\r\n      .mat-mdc-chip{\r\n        height: 24px !important;\r\n        float: left !important;\r\n        margin-inline: 1px !important;\r\n        .mdc-evolution-chip__text-label{\r\n          font-size: 12px !important;\r\n        }\r\n      }\r\n    }\r\n    }\r\n    .mat-mdc-form-field-subscript-wrapper{\r\n      display: none !important;\r\n    }\r\n  }\r\n  .mat-mdc-form-field-subscript-wrapper{\r\n    display: none !important;\r\n  }\r\n}\r\n::ng-deep.myCustomModalViewfilecase360 .modal-dialog\r\n{\r\n  margin: 0;\r\n  .modal-content{\r\n    width: 60vw;\r\n  }\r\n}\r\n::ng-deep.myCustomModalClasscase360audit .modal-dialog{\r\n  max-width: 97%;\r\n    max-height: 60%;\r\n    height: 60%;\r\n    margin-block: 0px !important;\r\n    margin: auto;\r\n    padding: 0 !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
